import { gql } from "@apollo/client";

export const GET_ACCOUNT_CLASSES_QUERY = gql`
    query ScheduleItemAttendance(
        $before: String
        $after: String
        $account: ID!
        $dateFrom: Date
        $dateTo: Date
    ) {
        scheduleItemAttendances(
            first: 20
            before: $before
            after: $after
            account: $account
            accountScheduleEventTicket_Isnull: true
            date_Gte: $dateFrom
            date_Lte: $dateTo
        ) {
            pageInfo {
                hasNextPage
                hasPreviousPage
                startCursor
                endCursor
            }
            edges {
                node {
                    id
                    cancellationPossible
                    uncancellationPossible
                    attendanceType
                    date
                    bookingStatus
                    isWaitlisted
                    waitlistPosition
                    joinedWaitlistAt
                    canCancelWaitlist
                    accountClasspass {
                        id
                        organizationClasspass {
                            name
                        }
                    }
                    accountSubscription {
                        id
                        organizationSubscription {
                            name
                        }
                    }
                    scheduleItem {
                        id
                        timeStart
                        timeEnd
                        organizationLocationRoom {
                            name
                            organizationLocation {
                                name
                            }
                        }
                        organizationClasstype {
                            name
                        }
                    }
                }
            }
        }
        user {
            id
            accountId
            firstName
            lastName
            fullName
            email
            gender
            dateOfBirth
            address
            postcode
            city
            country
            phone
            mobile
            emergency
        }
    }
`;

export const CANCEL_WAITLIST_MUTATION = gql`
    mutation CancelWaitlist($input: CancelWaitlistInput!) {
        cancelWaitlist(input: $input) {
            scheduleItemAttendance {
                id
                bookingStatus
                isWaitlisted
            }
        }
    }
`;
